import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { toast.error("Please enter your email."); return; }
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're subscribed! Watch your inbox for Lead ITES insights.");
      setEmail("");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Please enter a valid email address.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 w-full" data-testid="newsletter-form">
      <Input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@company.com"
        className="bg-white/10 border-white/20 text-white placeholder:text-white/40 h-11"
        data-testid="newsletter-email"
      />
      <Button type="submit" disabled={loading} className="btn-electric rounded-full px-6 h-11 shrink-0" data-testid="newsletter-submit">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Subscribe <Send className="h-4 w-4" /></>}
      </Button>
    </form>
  );
};

export default NewsletterSignup;
